import { Component } from '@angular/core';
import { IFloatingFilterAngularComp } from 'ag-grid-angular';
import { IFloatingFilterParams } from 'ag-grid-community';

@Component({
  selector: 'app-date-floating-filter',
  template: `
    <input
      class="ag-input"
      readonly
      (click)="openFilter()"
    />
  `,
  styles: [
    `
    .ag-input {
        width: 39px !important;
        height: 30px !important;
    }
    `
  ]
})
export class DateFloatingFilterComponent
  implements IFloatingFilterAngularComp {

  private params!: IFloatingFilterParams;

  agInit(params: IFloatingFilterParams): void {
    this.params = params;
  }

  openFilter(): void {
    this.params.showParentFilter();
  }

  onParentModelChanged(model: any): void {
    console.info("date range selection changed")
  }
}